export default __webpack_public_path__ + "static/media/accept.c1633d54.svg";